module.exports = __webpack_public_path__ + "img/active-layer1.cf17a420.png";